module.exports = __webpack_public_path__ + "img/gmail-remove-dashes.cb862c39.png";